import React, { useState } from "react";
import { Dialog, DialogContent } from "@material-ui/core";
import { toast } from "react-toastify";

import NavTabs from "../../components/NavTabs";
import Sidebar from "../../components/SideBar";
import List from "../../components/List";
import Label from "../../components/Label";
import Button from "../../components/Button";
import tableIcons from "../../config/tableIcons";
import SponsorForm from "./Register";
import EventApi from "../../services/event";

const LINE_STYLE = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "12px",
};

const Sponsors = () => {
    const [open, setOpen] = useState(false);
    const [editSponsor, setEditSponsor] = useState(null);
    const [tableKey, setTableKey] = useState(0);

    const columns = [
        { field: "id", title: "ID", type: "numeric", width: 60 },
        { field: "name", title: "Nome" },
        { field: "description", title: "Descrição" },
        { field: "total_slots", title: "Total de Vagas", type: "numeric" },
        { field: "occupied_slots", title: "Vagas Ocupadas", type: "numeric" },
        {
            title: "URL de Inscrição",
            field: "id",
            sorting: false,
            render: (row) => {
                const url = `${window.location.origin}/registro/patrocinador/${row.id}`;
                return (
                    <div style={{ display: "flex", alignItems: "center", gap: "6px", minWidth: 0 }}>
                        <span
                            style={{
                                fontSize: "12px",
                                color: "#555",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                maxWidth: "180px",
                            }}
                            title={url}
                        >
                            /registro/patrocinador/{row.id}
                        </span>
                        <button
                            title="Copiar URL"
                            onClick={() => {
                                navigator.clipboard.writeText(url).then(() =>
                                    toast.success("URL copiada!")
                                ).catch(() =>
                                    toast.error("Não foi possível copiar")
                                );
                            }}
                            style={{
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                background: "#f5f5f5",
                                cursor: "pointer",
                                padding: "2px 8px",
                                fontSize: "11px",
                                flexShrink: 0,
                            }}
                        >
                            📋 Copiar
                        </button>
                    </div>
                );
            },
        },
    ];

    const actions = [
        {
            icon: tableIcons.Edit,
            tooltip: "Editar",
            onClick: (e, row) => {
                setEditSponsor(row);
                setOpen(true);
            },
        },
        (row) => ({
            icon: tableIcons.Delete,
            tooltip: row.occupied_slots > 0 
                ? `Não é possível deletar: ${row.occupied_slots} participante(s) associado(s)` 
                : "Deletar Patrocinador",
            disabled: row.occupied_slots > 0,
            onClick: async (e, row) => {
                if (row.occupied_slots > 0) {
                    toast.error(
                        `Não é possível deletar o patrocinador "${row.name}" pois existem ${row.occupied_slots} participante(s) associado(s). ` +
                        `Remova ou reatribua os participantes antes de deletar.`
                    );
                    return;
                }
                if (!window.confirm(`Deletar o patrocinador "${row.name}"?`)) return;
                
                const resp = await EventApi.deleteSponsor(row.id);
                if (resp?.data === "success") {
                    toast.success("Patrocinador deletado com sucesso!");
                    setTableKey((k) => k + 1);
                } else {
                    const errorMsg = resp?.response?.data?.message || "Erro ao deletar patrocinador";
                    toast.error(errorMsg);
                }
            },
        }),
    ];

    const getRows = () =>
        EventApi.listSponsors()
            .then((resp) => {
                if (resp?.data) return resp.data.data;
                return [];
            })
            .catch(() => []);

    const handleOpen = () => {
        setEditSponsor(null);
        setOpen(true);
    };

    const handleClose = (refresh = false) => {
        setOpen(false);
        setEditSponsor(null);
        if (refresh) setTableKey((k) => k + 1);
    };

    const data = [
        {
            name: "Patrocinadores",
            content: (
                <List
                    key={tableKey}
                    columns={columns}
                    rows={[]}
                    getRows={getRows}
                    actions={actions}
                />
            ),
        },
    ];

    const page = (
        <>
            <div style={LINE_STYLE}>
                <Label size="min" color="dark" align="left" weight="500">
                    Patrocinadores Cadastrados
                </Label>
                <Button
                    size="nano"
                    color="dark"
                    format="solid"
                    width="auto"
                    onClick={handleOpen}
                >
                    Novo Patrocinador
                </Button>
            </div>
            <Dialog open={open} onClose={() => handleClose(false)} maxWidth="sm" fullWidth>
                <DialogContent>
                    <SponsorForm sponsor={editSponsor} close={handleClose} />
                </DialogContent>
            </Dialog>
            <div style={{ maxWidth: "100%" }}>
                <NavTabs itens={data} />
            </div>
        </>
    );

    return <Sidebar current="Patrocinadores" content={page} />;
};

export default Sponsors;
